import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { typeEstruturaComparativoInsumos } from './index';
import { HeaderDef } from './gerarPDFComparativoInsumos';
import { logo_ttivos_base64 } from '../../../../../../../Components/GerarExcel/meta';
import secureLocalStorage from "react-secure-storage";
import { numeroMilhar } from '../../../../../../../utils';

export const gerarExcelComparativoInsumos = async (
    dados: typeEstruturaComparativoInsumos[],
    headerInfo?: HeaderDef
) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Comparativo de Insumos', {
        views: [{ showGridLines: false }]
    });

    worksheet.columns = [
        { header: '', key: 'col1', width: 35 }, // Insumo
        { header: '', key: 'col2', width: 15 }, // Tipo
        { header: '', key: 'col3', width: 15 }, // Qtd. Planejada
        { header: '', key: 'col4', width: 15 }, // Qtd. Executada
        { header: '', key: 'col5', width: 15 }, // Desvio
        { header: '', key: 'col6', width: 10 }, // Uso
        { header: '', key: 'col7', width: 10 }, // Precisão
    ];

    let currentRow = 1;

    // ** HEADER **
    worksheet.getRow(currentRow).height = 40; // Linha para a imagem
    worksheet.getRow(currentRow + 1).height = 30; // Linha para o título
    worksheet.getRow(currentRow + 2).height = 20; // Linha para razao social

    // LOGO
    const headerImageId = workbook.addImage({
        base64: logo_ttivos_base64,
        extension: 'png',
    });

    worksheet.addImage(headerImageId, {
        tl: { col: 2.2, row: 0 },
        ext: { width: 121, height: 50 },
        editAs: 'LOGO TTIVOS'
    });
    worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
    const logoRow = worksheet.getRow(currentRow);
    logoRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    for (let i = 1; i <= 7; i++) {
        logoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = headerInfo?.titulo || 'Relatório Comparativo de Insumos';
    titleRow.getCell(1).font = { size: 16, bold: true };
    titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 7; i++) {
        titleRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;
    worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
    const razaoRow = worksheet.getRow(currentRow);
    razaoRow.getCell(1).value = headerInfo?.razaoSocial || '';
    razaoRow.getCell(1).font = { size: 10 };
    razaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 7; i++) {
        razaoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    // ** CLIENTE, SAFRA, CULTURA **
    if (headerInfo?.cliente) {
        worksheet.getRow(currentRow).height = 10; // Espaçamento superior
        currentRow++;

        // --- ROW DE RÓTULOS (Labels) ---
        worksheet.getRow(currentRow).height = 15;
        worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
        worksheet.mergeCells(`D${currentRow}:E${currentRow}`);
        worksheet.mergeCells(`F${currentRow}:G${currentRow}`);

        const labelRow = worksheet.getRow(currentRow);

        labelRow.getCell(1).value = 'CLIENTE';
        labelRow.getCell(4).value = 'SAFRA';
        labelRow.getCell(6).value = 'CULTURA';

        const labelFont = { size: 9, bold: true, color: { argb: 'FF7B7B7B' } };
        const centerAlignment = { horizontal: 'center', vertical: 'middle' } as const;

        labelRow.getCell(1).font = labelFont;
        labelRow.getCell(4).font = labelFont;
        labelRow.getCell(6).font = labelFont;

        labelRow.getCell(1).alignment = centerAlignment;
        labelRow.getCell(4).alignment = centerAlignment;
        labelRow.getCell(6).alignment = centerAlignment;

        currentRow++;

        // --- ROW DE VALORES ---
        worksheet.getRow(currentRow).height = 20;
        worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
        worksheet.mergeCells(`D${currentRow}:E${currentRow}`);
        worksheet.mergeCells(`F${currentRow}:G${currentRow}`);

        const valueRow = worksheet.getRow(currentRow);

        valueRow.getCell(1).value = (headerInfo.cliente || '-').toUpperCase();
        valueRow.getCell(4).value = (headerInfo.safra || '-').toUpperCase();
        valueRow.getCell(6).value = (headerInfo.cultura || '-').toUpperCase();

        const valueFont = { size: 11, bold: true, color: { argb: 'FF000000' } };

        valueRow.getCell(1).font = valueFont;
        valueRow.getCell(4).font = valueFont;
        valueRow.getCell(6).font = valueFont;

        valueRow.getCell(1).alignment = centerAlignment;
        valueRow.getCell(4).alignment = centerAlignment;
        valueRow.getCell(6).alignment = centerAlignment;

        // Adiciona bordas ao redor da nossa tabela de dados
        const borderStyle = { style: 'thin' as const, color: { argb: 'FF7B7B7B' } };

        const labelRowNumber = currentRow - 1;
        const valueRowNumber = currentRow;

        for (let col = 1; col <= 7; col++) {
            worksheet.getRow(labelRowNumber).getCell(col).border = {
                top: borderStyle,
                left: col === 1 || col === 4 || col === 6 ? borderStyle : undefined,
                right: col === 3 || col === 5 || col === 7 ? borderStyle : undefined,
            };
            worksheet.getRow(valueRowNumber).getCell(col).border = {
                bottom: borderStyle,
                left: col === 1 || col === 4 || col === 6 ? borderStyle : undefined,
                right: col === 3 || col === 5 || col === 7 ? borderStyle : undefined,
            };
        }

        currentRow++;
    }

    currentRow++; // linha vazia

    const applyBorders = (rowNum: number, color = 'FF000000') => {
        const row = worksheet.getRow(rowNum);
        for (let i = 1; i <= 7; i++) {
            row.getCell(i).border = {
                top: { style: 'thin', color: { argb: color } },
                left: { style: 'thin', color: { argb: color } },
                bottom: { style: 'thin', color: { argb: color } },
                right: { style: 'thin', color: { argb: color } }
            };
        }
    };

    dados.forEach((propriedade) => {
        worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
        const propRow = worksheet.getRow(currentRow);
        propRow.getCell(1).value = propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA";
        propRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
        propRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5DA57D' } };
        propRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        propRow.height = 25;
        applyBorders(currentRow, 'FF165C13');
        currentRow++;

        propriedade.lista_insumos_por_talhao.forEach((talhao) => {
            worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
            const talhaoRow = worksheet.getRow(currentRow);
            talhaoRow.getCell(1).value = `${talhao.nome_talhao || "TALHÃO NÃO INFORMADO"} - ${talhao.area || 0} ha`;
            talhaoRow.getCell(1).font = { bold: true, color: { argb: 'FF165C13' }, size: 11 };
            talhaoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            talhaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            talhaoRow.height = 20;
            applyBorders(currentRow, 'FF165C13');
            currentRow++;

            const headerTitles = ['Insumo', 'Tipo', 'Qtd. Planejada', 'Qtd. Executada', 'Desvio', 'Uso', 'Precisão'];
            const colHeaderRow = worksheet.getRow(currentRow);
            headerTitles.forEach((title, index) => {
                const cell = colHeaderRow.getCell(index + 1);
                cell.value = title;
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            colHeaderRow.height = 20;
            applyBorders(currentRow, 'FF000000');
            currentRow++;

            let globalInsumoIndex = 0;

            talhao.lista_insumos.forEach((insu) => {
                const zebraColor = (globalInsumoIndex % 2 === 0) ? 'FFFFFFFF' : 'FFE5F1E1';

                const desvioCalculado = (insu.quantidade_executada || 0) - (insu.quantidade_planejada || 0);
                const desvioFormatado = `${numeroMilhar(desvioCalculado)} ${insu.medida || ''}`.trim();
                const usoFormatado = `${insu.porcentagem || 0}%`.replace(/\s/g, '');
                const precisaoFormatado = `${insu.precisao || 0}%`.replace(/\s/g, '');
                const qtdPlanejadaFormatado = Number(insu.quantidade_planejada || 0) === 0 ? '-' : `${numeroMilhar(insu.quantidade_planejada)} ${insu.medida || ''}`.trim();
                const qtdExecutadaFormatado = Number(insu.quantidade_executada || 0) === 0 ? '-' : `${numeroMilhar(insu.quantidade_executada)} ${insu.medida || ''}`.trim();

                let corFundoPrecisao = zebraColor;
                let corTextoPrecisao = 'FF000000'; // Default text color is black
                const p = insu.precisao || 0;

                if (p === 100) {
                    corFundoPrecisao = 'FFEEFDDE'; // Verde '#eefdde'
                    corTextoPrecisao = 'FF55C51E'; // '#55c51e'
                } else if (p < 100 && p >= 95) {
                    corFundoPrecisao = 'FFDFECF7'; // Azul '#dfecf7'
                    corTextoPrecisao = 'FF0857D8'; // '#0857d8'
                } else if (p < 95 && p >= 80) {
                    corFundoPrecisao = 'FFFFF7CC'; // Amarelo '#fff7cc'
                    corTextoPrecisao = 'FF000000'; // black
                } else if (p < 80) {
                    corFundoPrecisao = 'FFFFE7E7'; // Vermelho '#ffe7e7'
                    corTextoPrecisao = 'FFD60024'; // '#d60024'
                }

                const atvRow = worksheet.getRow(currentRow);
                atvRow.getCell(1).value = `${insu.insumo_nome} ${insu.tipo_nome === 'Biológico' ? ` (${insu.tipo_fisico})` : ''}`;
                atvRow.getCell(2).value = insu?.tipo_nome || '-';
                atvRow.getCell(3).value = qtdPlanejadaFormatado;
                atvRow.getCell(4).value = qtdExecutadaFormatado;
                atvRow.getCell(5).value = desvioFormatado;
                atvRow.getCell(6).value = usoFormatado;
                atvRow.getCell(7).value = precisaoFormatado;

                atvRow.height = 25;

                for (let i = 1; i <= 6; i++) {
                    const cell = atvRow.getCell(i);
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    // Default zebra coloring for first 6 cols
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                }

                // Precisão column uses specific coloring
                const precisaoCell = atvRow.getCell(7);
                precisaoCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                precisaoCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: corFundoPrecisao } };
                precisaoCell.font = { color: { argb: corTextoPrecisao }, bold: true };

                applyBorders(currentRow, 'FF000000');
                currentRow++;
                globalInsumoIndex++;
            });

            if (talhao.lista_insumos.length === 0) {
                worksheet.mergeCells(`A${currentRow}:G${currentRow}`);
                const emptyRow = worksheet.getRow(currentRow);
                emptyRow.getCell(1).value = 'Nenhum insumo planejado para este talhão.';
                emptyRow.getCell(1).font = { italic: true };
                emptyRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                emptyRow.height = 25;
                applyBorders(currentRow, 'FF000000');
                currentRow++;
            }

            currentRow++; // empty space between talhoes
        });
        currentRow++; // empty space between propriedades
    });

    // ** FOOTER **
    const espacoRow = worksheet.addRow([]);
    espacoRow.height = 20;

    const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
    const footerRow = worksheet.addRow([]);
    footerRow.getCell(1).value = `Gerado por: ${email_usuario_logado} - ${dayjs().format('DD/MM/YYYY HH:mm:ss')}`;
    footerRow.font = { italic: true };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    for (let i = 1; i <= 7; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${footerRow.number}`).border = {
            top: { style: 'thin', color: { argb: 'FF5DA57D' } } // Fixed argb valid value
        };
    }
    worksheet.mergeCells(`A${footerRow.number}:G${footerRow.number}`);
    footerRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Relatorio_Comparativo_Insumos_${dayjs().format("DD_MM_YYYY_HH_mm")}.xlsx`);
};
